import { Routes, Route } from "react-router-dom";


import Navbar from "../src/Components/Navbar/Navbar";
import Hero from "../src/Components/Hero/Hero";
import BrandStatement from "./Components/BrandStatement/BrandStatement";
import Showreel from "./Components/Showreel/Showreel";
import FeaturedWork from "./Components/FeaturedWork/FeaturedWork";
import Services from "./Components/Services/Services";
import Industries from "./Components/Industries/Industries";
import CreativeProcess from "./Components/CreativeProcess/CreativeProcess";

import Testimonials from "./Components/Testimonials/Testimonials";

import ContactCTA from "./Components/ContactCTA/ContactCTA";
import Footer from "./Components/Footer/Footer";


import Work from "./Pages/Work/Work";
import ProjectDetail from "./Pages/ProjectDetail/ProjectDetail";
import ServicesPage from "./Pages/ServicesPage/ServicesPage";
import About from "./Pages/AboutPage/AboutPage";
import Contact from './Pages/ContactPage/ContactPage'


import SmoothScroll from "../src/Components/SmoothScroll/SmoothScroll"
import ScrollToTop from "./Components/ScrollToTop/ScrollToTop";


function Home() {
  return (
    <>
      <Navbar />

      <main>
        <Hero />
        <BrandStatement />
        <Showreel />
        <FeaturedWork />
        <Services />
        <Industries />
        <CreativeProcess />
        <Testimonials />
        
        <ContactCTA />
      </main>

      <Footer />
    </>
  );
}

function App() {
  return (
    <>
     <SmoothScroll />
     <ScrollToTop/>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/work" element={<Work />} />
      <Route path="/work/:slug" element={<ProjectDetail />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/about" element={<About/>} />
    
      <Route path="/contact" element={<Contact/>} />
    </Routes>
  </>
  );
}

export default App;